<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <div>
        <DistributeIpMenu ref='DistributeTableButton' @notify='notify' @keywords='changeKeywords'
          :refreshBtn='true' :exportBtn='true' :deleteBtn='true' :keywordsInput='true' :exportTemplateBtn ='true'
          :importBtn='true' :detailBtn='true'>
        </DistributeIpMenu>
        <DistributeIpTable ref='distributeTable'></DistributeIpTable>
      </div>
    </template>
  </BasicLayout>
</template>

<script>

import dhcpDataReceive from '@/plugins/stompSock';

import BasicLayout from '../../layouts/BasicLayout';
import DistributeIpMenu from '../../components/software/DistributeMenuButton';
import DistributeIpTable from '../../components/software/DistributeIpTable';

export default {
  name: 'TscIpAutoDistributePage',
  components: {
    BasicLayout,
    DistributeIpMenu,
    DistributeIpTable,
  },
  data() {
    return {
      left: {
        show: false,
        name: ''
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('Software.softManage_Automantic')}`
      },

      payload: [
        { topic: '/user/#/DHCPServer', clientId: '', callback: this.dhcpReceiveLisener }
      ]

    };
  },
  methods: {
    changeKeywords(args) {
      this.$refs.distributeTable.queryConditions.keywords = args;
    },
    notify(type) {
      switch (type) {
        case 'refresh':
          this.$refs.distributeTable.getIpListData();
          break;
        case 'export':
          this.$refs.distributeTable.exportIpListData();
          break;
        case 'exportTemplate':
          this.$refs.distributeTable.exportTemplate();
          break;
        case 'import':
          this.$refs.distributeTable.importDHCP();
          break;
        case 'delete':
          this.$refs.distributeTable.deleteIpData();
          break;
        case 'detail':
          this.$refs.distributeTable.showDetail();
          break;
        case 'keywords':
          this.$refs.distributeTable.getIpListData();
          break;
        default:
          break;
      }
    },
    dhcpReceiveLisener(response) {
      const msg = JSON.parse(response.body);
      const { elecsnId } = msg;
      const { eqtGroupId } = msg;
      const { ip } = msg;
      const { usage } = msg;

      this.$refs.distributeTable.grid.setCellValue(eqtGroupId, 'usage', usage);
      this.$refs.distributeTable.$refs.DHCPDetail.grid.setCellValue(ip, 'status', this.$t('Software.allocated'));
    },
    initWebsocket() {
      const socketId = 1669485411;
      if (!dhcpDataReceive.socket || dhcpDataReceive.socket.readyState === 2 || dhcpDataReceive.socket.readyState === 3) {
        this.payload[0].clientId = socketId;
        dhcpDataReceive.init(this.payload);
      } else if (dhcpDataReceive.subscribes[dhcpDataReceive.__buildSubscribeTopic(socketId, this.payload[0].topic)]) {
        console.log('-!-');
      } else {
        dhcpDataReceive.dynamicSubscribe(this.payload[0].topic, socketId, this.payload[0].callback);
      }
    }
  },
  mounted() {
    this.initWebsocket();
  }
};
</script>
<style>
  e-upload-actions {
    display: none;
  }
</style>
